<template>
  <div class="row">
    <div class="col-xl-12 order-xl-1">
      <spinner v-show="!isLoaded"></spinner>
      <card v-show="isLoaded" card-body-classes="table-full-width" no-footer-line>
        <h4 slot="header" class="card-title">Liste des abonnements</h4>
        <div slot="header" class="col-12 text-right" style="margin-bottom: 10px; margin-top: -50px">
          <input type="text" valid="true" placeholder="Recherche" @keypress="search" @keydown="search" class="MySearch form-control">
          <n-button  type="primary" class="btn btn-sm btn-primary" @click.native="excelExport()">
            <span><i class="fas fa-file-csv"></i></span>
          </n-button>
          <n-button  type="primary" class="btn btn-sm btn-primary" @click.native="openChooserColumnMenu()">
            <span><i class="fas fa-columns"></i></span>
          </n-button>
<!--          <n-button  type="primary" class="btn btn-sm btn-primary" @click.native="addCommand()">-->
<!--            <span><i class="fas fa-plus"></i></span>-->
<!--          </n-button>-->
        </div>
        <div class="mr-4 ml-4 mb-4">
          <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"></div>
          <!-- Syncfusion Table here -->
          <ejs-grid ref='subscriptionList' id="Grid" :dataSource="tableData" :enablePersistence='false'
                    :allowReordering='true' :rowDataBound="rowDataBound"
                    :allowResizing='true'  :showColumnChooser='true'
                    :allowSelection='true' :allowPaging="true"
                    :allowSorting='true' :allowGrouping='false'
                    :editSettings='editSettings' :pageSettings='pageSettings' :sortSettings='sortOptions'
                    :allowExcelExport='true' class="subscription-datagrid">
            <e-columns>
              <e-column field='key' headerText='' :visible="false" :showInColumnChooser='false' isPrimaryKey="true" textAlign='Left' width=80></e-column>
              <e-column field='subscription_detail' :disableHtmlEncode="false" headerText='Abonnement'  textAlign='Left' width=80></e-column>
              <e-column field='customer' headerText='Client(s)' textAlign='Left' width=80></e-column>
              <e-column field='commercial' headerText='Commercial' textAlign='Left' width=80></e-column>
              <e-column field='device_detail' :disableHtmlEncode="false" headerText='Équipement' textAlign='Left' width=80></e-column>
              <e-column field='start_date' headerText='Date de début' :format='dateFormat' type='date' textAlign='Center' width=70></e-column>
              <e-column field='expirationDate' headerText="Date d'expiration" :format='dateFormat' type='date' textAlign='Center' width=70></e-column>
              <e-column field='resiliation_date' headerText="Date de résialation" :format='dateFormat' type='date'  textAlign='Center' width=70></e-column>
              <e-column field='commands' headerText=''  textAlign='Center' minWidth=40 width=40 :commands='commands'></e-column>
            </e-columns>
          </ejs-grid>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import { GridPlugin, Page, Search,  Sort, Filter, Group, ForeignKey, ExcelExport , DetailRow, ColumnChooser, Toolbar, Resize, Reorder, Edit, CommandColumn} from "@syncfusion/ej2-vue-grids";
import Spinner from "src/components/Spinner/Circle";
import Authorizable from '@/mixins/authorizable'
import moment from "moment";


export default {
  name: "SubscriptionList",
  mixins: [Authorizable],
  components: {
    Spinner,
  },
  data() {
    return {
      isLoaded: false,
      editSettings: { allowEditing: false, allowDeleting: true },
      // searchOptions: {fields: ['command_number', 'customer_command_number', 'detailTemplate', 'customer']},
      dateFormat: { type: 'date', format: 'dd/MM/yyyy' },
      pageSettings: { pageSize: 15, pageSizes: true },
      sortOptions: { columns: [{ field: 'expirationDate', direction: 'Descending' }, ] }, // oTHER OPTIONS/ Ascending
      commands: [
        { buttonOption: { cssClass: 'e-flat', iconCss: 'e-icons', click: this.resiliationButton  }}
      ],
      tableData: [],
      subscriptionList: [],
    }
  },
  provide: {
    grid: [Page, Search, ForeignKey, Sort, Filter, Group, ExcelExport, DetailRow, ColumnChooser, Resize, Reorder, Edit, CommandColumn]
  },
  mounted(){
    this.fetchData()
  },
  methods: {
    fetchData(){
      this.axios.get(process.env.VUE_APP_API_BASE_URL+`subscriptions/list`).catch(error => {
        this.$notify({message: "Une erreur est survenue lors du chargement des abonnements", type: 'danger', verticalAlign: 'bottom'})
      }).then( response => {

        this.subscriptionList = response.data
        var fillSubscriptionList = new Promise((resolve, rejected) => {
          this.subscriptionList.forEach( (subscription, index, array) =>{
            subscription.subscription_detail = '<p class="first-row-cell">'+subscription.subscription.name+'</p><p class="second-row-cell">'+subscription.subscription.command_number+' - '+subscription.subscription.ref+'</p>'
            subscription.device_detail = '<p class="first-row-cell">'+subscription.device.name+' - '+subscription.device.command_number+'</p><p class="second-row-cell">'+subscription.device.metatada_name+': '+subscription.device.metatada_value+'</p>'
            subscription.start_date = subscription.subscription.start_date
            subscription.expiration_date = moment(subscription.subscription.start_date).add(subscription.subscription.duration,'d').format('DD/MM/YYYY')
            subscription.expirationDate = moment(subscription.subscription.start_date).add(subscription.subscription.duration,'d').format('YYYY-MM-DD')
            subscription.key = subscription.subscription.id
            if(subscription.subscription.resiliation_date!== null){
              subscription.resiliation_date = subscription.subscription.resiliation_date
            }
            if(index === array.length - 1) resolve();
          })
          if(this.subscriptionList.length === 0) resolve();
        })

        fillSubscriptionList.then(response => {
          this.tableData = this.subscriptionList
          this.isLoaded = true
        })
      })
    },
    // Permet de résilier un abonnement
    resiliationButton: function (args){
      var rowEle = $(args.target).parents('.e-row')
      var rowIndex = parseInt(rowEle[0].getAttribute('aria-rowindex'))
      this.$refs.subscriptionList.selectRow(rowIndex)
      var rowData = { ...this.$refs.subscriptionList.getSelectedRecords()[0]};

      this.axios.get(process.env.VUE_APP_API_BASE_URL+`subscription/resiliation`, {
        params: {
          subscription_id: rowData.subscription.id
        }
      }).then((response) => {
        if(response.data.resiliation === 'resiliation added'){
          this.$notify({message: "L'abonnement a bien été résilié", type: 'success', verticalAlign: 'bottom'})
          rowData['resiliation_date'] = moment();
         this.$refs.subscriptionList.updateRow(rowIndex,rowData);
        } else if(response.data.resiliation === 'resiliation removed') {
          this.$notify({message: "La résiliation de cet abonnement à été supprimée", type: 'success', verticalAlign: 'bottom'})
          rowData['resiliation_date'] = null
         this.$refs.subscriptionList.updateRow(rowIndex,rowData);
        }
      })
    },
    // Permet de faire une recherche dans le tableau
    search: function() {
      let searchText = document.getElementsByClassName('MySearch')[0].value;
      this.$refs.subscriptionList.search(searchText);
    },
    // Permet d'exporter le résultat dans un tableur
    excelExport: function(args) {
      this.$refs.subscriptionList.excelExport();
    },
    // Ouvre la modal SyncFusion dédiée au choix des colonnes
    openChooserColumnMenu(){
      this.$refs.subscriptionList.openColumnChooser()
    },

    rowDataBound: function(args){
      var commandColumnIndex = parseInt(this.$refs.subscriptionList.getColumnHeaderByField('commands').ariaColIndex)
      args.row.cells[commandColumnIndex].firstElementChild.children[0].firstElementChild.classList = "e-btn-icon fas fa-times-circle resiliation-button e-icons"

      if(args.data.resiliation_date !== null  && args.data.resiliation_date !== undefined ){
        args.row.style.backgroundColor = '#f9acaa'
      }
      else{
        args.row.style.backgroundColor = 'rgba(255,255,255,0)'
      }

      if(args.data.subscription.has_been_renew === true){
        args.row.style.backgroundColor = 'rgb(162, 245, 191)'
      }
    },

  }
}
</script>

<style>
.first-row-cell {
  font-size: 13px; margin-top: 0px; font-weight: 600
}

.second-row-cell{
  margin-top: -17px; margin-bottom: 0; font-size: 12px; font-style: italic;
}
.resiliation-button {
  font-size: 22px !important;
  color: #b7b7b7 !important;
}
</style>
